import constants from '../constants/actions';
import APP from 'app';

const { Utils } = APP,
    { getUserInfoFromJwt, getJwtToken, updateJWT } = Utils,

    initialState = {
        userInfo: {},
        otpJson: {},
        success: false,
        error: false,
        errors: [],
        registerJson: {},
        registerSuccess: false,
        forgetJson: {},
        forgetSuccess: false,
        loading: false,
        loaderFlag: false,
        userData: {}
    };

export default function userInfoReducer(state = initialState, action) {

    switch (action.type) {
        case constants.USERINFO.USERINFO_FROM_JWT: {
            const { type = '', payload = {} } = action,
                { userInfoformJwt } = payload;
            return {
                ...state,
                type,
                userInfo: userInfoformJwt
            };
        }
        case constants.REFRESH.USER_JWT_UPDATED: {
            const updatedUserInfo = getUserInfoFromJwt();
            const jwtToken = getJwtToken();
            return {
                ...state,
                userInfo: updateJWT(state, updatedUserInfo, jwtToken)
            };
        }
        case constants.USER.USER_REGISTER_SUCCESS: {
            const registerJson = action.payload;
            return {
                ...state,
                registerJson,
                registerSuccess: true,
                loaderFlag: false,
            };
        }
        case constants.USER.USER_REGISTER_FAILURE: {
            const registerJson = action.payload;
            return {
                ...state,
                registerJson,
                registerSuccess: false,
                loaderFlag: false,
            };
        }
        case constants.USER.USER_LOGIN_SUCCESS: {
            const { user } = action.payload;
            const { role = '' } = user;
            const { accessToken } = action.payload;
            const userInfo = { ...user, accessToken };
            return {
                ...state,
                userInfo: userInfo,
                success: role != 'GUEST',
                error: false,
                loaderFlag: false,
            };
        }
        case constants.USER.FORGET_PASSWORD_SUCCESS: {
            const forgetJson = action.payload;
            return {
                ...state,
                forgetJson,
                forgetSuccess: true,
                loaderFlag: false,
            };
        }
        case constants.USER.FORGET_PASSWORD_FAILURE: {
            const forgetJson = action.payload;
            return {
                ...state,
                forgetJson,
                forgetSuccess: false,
                loaderFlag: false,
            };
        }
        case constants.USER.USER_LOGIN_FAILURE: {
            let error = action.payload.errors ? action.payload.errors.message : "Something went wrong!";
            let errors = action.payload.errors || [];
            return {
                ...state,
                error: error,
                errors: errors,
                success: false,
                loaderFlag: false,
            };
        }
        case constants.USER.OTP_SUCCESS: {
            const otpJson = action.payload;
            return {
                ...state,
                otpJson,
                loaderFlag: false,
            };

        }
        case constants.USER.POPUP_LOADER_REQUEST: {
            return {
                ...state,
                loaderFlag: true,
                success: false
            }
        }
        case constants.USER.OTP_FAILURE: {
            const otpJson = action.payload;
            return {
                ...state,
                otpJson,
                loaderFlag: false,
            };
        }
        case constants.USERINFO.LOADER_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }

        case constants.USERINFO.USER_DUES: {
            const { oldDueInfo = [] } = action.payload,
                { userInfo = {} } = state,
                { ds = {} } = userInfo
            return {
                ...state,
                userInfo: {
                    ...userInfo,
                    ds: {
                        ...ds,
                        oldDueInfo: oldDueInfo
                    }
                },
                loading: false
            };
        }
        case constants.USERINFO.USERINFO_FROM_API: {
            const { type = '', payload = {} } = action
            return {
                ...state,
                type,
                userData: payload
            };
        }
        default:
            return state;
    }
}
